var App = App || {};

App.BulkEventRegistration = (function () {
	"use strict";

	function TreeNode(node, parent) {
		var self = this;
		self.parent = parent || null;
		self.title = node.title;
		self.type = node.type;
		self.id = node.id || null;
		self.isActive = node.isActive;
		self.checkboxId = "node-" + node.id;
		self.depth = parent ? (parent.depth + 1) : 0;

		self.children = ko.observableArray(
			(node.children || []).map(function (c) {
				return new TreeNode(c, self);
			})
		);

		self.expanded = ko.observable(self.isActive);
		self.state = ko.observable("unchecked");

		self.checked = ko.pureComputed({
			read: function () { return self.state() === "checked"; },
			write: function (val) {
				self.setState(val ? "checked" : "unchecked", true, true);
			}
		});

		self.setState = function (value, down, up) {
			if (!self.isActive)
				return;

			self.state(value);

			if (down) {
				self.children().forEach(function (c) {
					c.setState(value, true, false);
				});
			}

			if (up && self.parent) {
				self.parent.syncFromChildren();
			}
		};

		self.syncFromChildren = function () {
			var children = self.children();
			if (!children.length)
				return;

			var checked = 0;
			var unchecked = 0;

			children.forEach(function (c) {
				if (c.state() === "checked") checked++;
				else if (c.state() === "unchecked") unchecked++;
			});

			var next =
				checked === children.length ? "checked" :
					unchecked === children.length ? "unchecked" :
						"indeterminate";

			self.state(next);

			if (self.parent) {
				self.parent.syncFromChildren();
			}
		};

		self.collectSelectedEvents = function (list) {
			if (self.type === "Page_RegistrationEvent" && self.state() === "checked") {
				list.push(self);
			}

			self.children().forEach(function (c) {
				c.collectSelectedEvents(list);
			});
		};

	}

	function EventRegistrationVm(treeData) {
		var self = this;

		self.root = new TreeNode(treeData, null);

		self.attendees = ko.observableArray([]);

		self.sortedAttendees = ko.pureComputed(function () {
			return self.attendees()
				.slice()
				.sort(function (a, b) {
					var nameA = (a.name || "").toLowerCase();
					var nameB = (b.name || "").toLowerCase();

					if (nameA < nameB) return -1;
					if (nameA > nameB) return 1;
					return 0;
				});
		});


		self.attendeeName = ko.observable("");
		self.attendeeEmail = ko.observable("");
		self.attendeePhone = ko.observable("");
		self.isSubmitting = ko.observable(false);

		self.selectedEvents = ko.pureComputed(function () {
			var list = [];
			self.root.collectSelectedEvents(list);
			return list;
		});

		self.canSubmit = ko.pureComputed(function () {
			return self.attendees().length > 0 && self.selectedEvents().length > 0 && !self.isSubmitting();
		});

		self.buildPayload = function () {
			return {
				eventIds: self.selectedEvents().map(item => item.id),
				attendees: self.attendees()
			};
		};

		self.submitRegistration = function (data, event) {
			var $submitButton = $(event.currentTarget);

			if (self.attendees().length === 0) {
				App.Base.ShowError("Add at least one attendee before submitting.");
				return;
			}

			if (self.selectedEvents().length === 0) {
				App.Base.ShowError("Select at least one event before submitting.");
				return;
			}

			self.isSubmitting(true);
			App.Spinner.startSpinner($submitButton, "Processing");

			$.ajax({
				url: "/api/bulk-event-registration/process",
				method: "POST",
				contentType: "application/json; charset=utf-8",
				dataType: "json",
				data: JSON.stringify(self.buildPayload())
			}).done(function (response) {
				if (response && response.status && response.status === 'Success') {
					App.Base.ShowInformation(response.message || "Submitted successfully.");
					self.clearSessionState();
					self.attendees.removeAll();
					self.clearAll();
				} else {
					App.Base.ShowError(response.message || "Submit failed.");
				}
			}).fail(function (xhr) {
				var msg = "Submit failed.";
				if (xhr && xhr.responseJSON && xhr.responseJSON.message)
					msg = xhr.responseJSON.message;

				App.Base.ShowError(msg);
			}).always(function () {
				self.isSubmitting(false);
				App.Spinner.stopSpinner($submitButton, "Processing");
			});
		};

		self.onAttendeeKeyup = function (data, event) {
			if (event.key === "Enter" || event.keyCode === 13) {
				event.preventDefault();
				self.addAttendee();
				return false;
			}
			return true;
		};

		self.addAttendee = function () {
			const $form = $("#attendee-form");
			$form.removeClass("was-validated");
			if ($form[0].checkValidity()) {
				self.attendees.push({
					name: (self.attendeeName() || "").trim(),
					email: (self.attendeeEmail() || "").trim(),
					phone: self.attendeePhone()
				});

				self.attendeeName("");
				self.attendeeEmail("");
				self.attendeePhone("");
				$("input#registration-name").trigger("focus");
			}
			else {
				applyValidationMessages($form);

			}
		};

		self.removeAttendee = function (attendee) {
			self.attendees.remove(attendee);
		};

		self.expandAll = function () {
			walk(self.root, function (n) { n.expanded(true); });
		};

		self.collapseAll = function () {
			walk(self.root, function (n) { n.expanded(false); });
		};

		self.selectAll = function () {
			self.root.setState("checked", true, false);
		};

		self.clearAll = function () {
			self.root.setState("unchecked", true, false);
		};

		self._persistKey = null;
		self._saveTimer = null;
		self._isRestoring = false;

		self.clearSessionState = function () {
			if (!self._persistKey) return;
			try { localStorage.removeItem(self._persistKey); } catch (e) { }
		};

		self._scheduleSave = function () {
			if (self._isRestoring) return;
			if (!self._persistKey) return;

			if (self._saveTimer) clearTimeout(self._saveTimer);
			self._saveTimer = setTimeout(function () {
				self._saveTimer = null;
				self._saveNow();
			}, 250);
		};

		self._buildSessionDto = function () {
			var nodeStates = {};
			var expandedStates = {};

			walk(self.root, function (n) {
				if (!n || !n.id) return;
				nodeStates[n.id] = n.state();
				expandedStates[n.id] = !!n.expanded();
			});

			return {
				attendees: self.attendees().slice(),
				attendeeName: self.attendeeName(),
				attendeeEmail: self.attendeeEmail(),
				attendeePhone: self.attendeePhone(),
				nodeStates: nodeStates,
				expandedStates: expandedStates
			};
		};

		self._saveNow = function () {
			var dto = self._buildSessionDto();
			var json = safeJsonStringify(dto);
			if (!json) return;

			try { localStorage.setItem(self._persistKey, json); } catch (e) { }
		};

		self.restoreSessionState = function (nodeId) {
			self._persistKey = storageKey(nodeId);

			var raw = null;
			try {
				raw = localStorage.getItem(self._persistKey);
			} catch (e) {
				raw = null;
			}

			var dto = safeJsonParse(raw);
			if (!dto)
				return;

			self._isRestoring = true;

			try {
				if (Array.isArray(dto.attendees))
					self.attendees(dto.attendees);

				if (typeof dto.attendeeName === "string")
					self.attendeeName(dto.attendeeName);

				if (typeof dto.attendeeEmail === "string")
					self.attendeeEmail(dto.attendeeEmail);

				if (typeof dto.attendeePhone === "string")
					self.attendeePhone(dto.attendeePhone);

				var nodeStates = dto.nodeStates || {},
					expandedStates = dto.expandedStates || {},
					didApplyDefinitiveState = false;

				walk(self.root, function (n) {
					if (!n || !n.id) return;


					if (Object.prototype.hasOwnProperty.call(expandedStates, n.id)) {
						n.expanded(!!expandedStates[n.id]);
					}

					if (Object.prototype.hasOwnProperty.call(nodeStates, n.id)) {
						var s = nodeStates[n.id];

						if (s === "checked" || s === "unchecked") {
							n.setState(s, false, false);
							didApplyDefinitiveState = true;
						}
					}
				});

				if (didApplyDefinitiveState) {
					walk(self.root, function (n) {
						if (n && n.children && n.children().length) {
							n.syncFromChildren();
						}
					});
				}
			}
			finally {
				self._isRestoring = false;
			}

			self._scheduleSave();
		};


		self._wirePersistence = function () {
			self.attendees.subscribe(self._scheduleSave);
			self.attendeeName.subscribe(self._scheduleSave);
			self.attendeeEmail.subscribe(self._scheduleSave);
			self.attendeePhone.subscribe(self._scheduleSave);

			walk(self.root, function (n) {
				n.state.subscribe(self._scheduleSave);
				n.expanded.subscribe(self._scheduleSave);
			});
		};

		self._wirePersistence();
	}

	function storageKey(nodeId) {
		return "BulkEventRegistration:v1:" + nodeId;
	}

	function safeJsonParse(raw) {
		if (!raw) return null;
		try { return JSON.parse(raw); } catch (e) { return null; }
	}

	function safeJsonStringify(obj) {
		try { return JSON.stringify(obj); } catch (e) { return null; }
	}

	function walk(node, fn) {
		fn(node);
		node.children().forEach(function (c) {
			walk(c, fn);
		});
	}


	function applyValidationMessages($form) {
		$form.find(":invalid").each(function () {
			let msg = "";

			switch (true) {
				case this.validity.valueMissing:
					msg = $(this).data("val-required") || "A value is required.";
					break;
				case this.validity.typeMismatch:
					msg = $(this).data("val-type") || "Incorrect format.";
					break;
				default:
					msg = this.validationMessage || "";
					break;
			}
			$form.addClass("was-validated");
			$(this).siblings(".field-validation-error").text(msg);
		});
	}


	function init() {
		if (!ko.bindingHandlers.indeterminate) {
			ko.bindingHandlers.indeterminate = {
				update: function (element, valueAccessor) {
					element.indeterminate = !!ko.unwrap(valueAccessor());
				}
			};
		}

		if (!ko.bindingHandlers.phoneMask) {
			function formatPhone(raw) {
				var d = (raw || "").toString().replace(/\D/g, "").slice(0, 11);
				if (!d) return "";

				if (d.length === 11 && d[0] === "1") {
					d = d.slice(1);
				}

				function fmt10(x) {
					var a = x.slice(0, 3), b = x.slice(3, 6), c = x.slice(6);
					if (x.length <= 3) return "(" + a + (x.length === 3 ? ") " : "");
					if (x.length <= 6) return "(" + a + ") " + b;
					return "(" + a + ") " + b + "-" + c;
				}

				if (d.length <= 7)
					return d.length <= 3 ? d : d.slice(0, 3) + "-" + d.slice(3);

				return fmt10(d.slice(0, 10));
			}


			function caretFromDigitIndex(formatted, digitIndex) {
				if (!digitIndex) return 0;

				var count = 0;
				for (var i = 0; i < formatted.length; i++) {
					if (/\d/.test(formatted.charAt(i))) {
						count++;
						if (count >= digitIndex)
							return i + 1;
					}
				}
				return formatted.length;
			}

			ko.bindingHandlers.phoneMask = {
				init: function (element, valueAccessor) {
					var obs = valueAccessor();

					function write(val) {
						if (element.value !== val) element.value = val;
						if (ko.isObservable(obs)) obs(val);
					}

					function onInput() {
						var raw = element.value || "";
						var caret = element.selectionStart || 0;
						var digitsBefore = raw.slice(0, caret).replace(/\D/g, "").length;

						var formatted = formatPhone(raw);
						write(formatted);

						if (typeof element.setSelectionRange === "function") {
							var nextCaret = caretFromDigitIndex(formatted, digitsBefore);
							element.setSelectionRange(nextCaret, nextCaret);
						}
					}

					ko.utils.registerEventHandler(element, "input", onInput);
					ko.utils.registerEventHandler(element, "blur", onInput);

					write(formatPhone(ko.unwrap(obs)));
				},

				update: function (element, valueAccessor) {
					var formatted = formatPhone(ko.unwrap(valueAccessor()));
					if (element.value !== formatted)
						element.value = formatted;
				}
			};
		}

		var $root = $("#bulk-event-registration");
		if (!$root.length)
			return;

		var nodeId = ($root.data("node-id") || "").toString();
		if (!nodeId)
			return;


		if ($root.data("mounted") === "1")
			return true;

		$.getJSON('/api/bulk-event-registration/get-all', { nodeId: nodeId })
			.done(function (treeData) {
				var vm = new EventRegistrationVm(treeData);
				vm.restoreSessionState(nodeId);
				ko.applyBindings(vm, $root[0]);
				$root.data("mounted", "1");
			})
			.fail(function () {
				$root.data("mounted", null);
			});
	}

	return {
		init: init
	};

})();

(function () {
	App.BulkEventRegistration.init();
})();